import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 8.5L2 8.5L2 6.5L8 0.500001L14 6.5L14 8.5L10 8.5L10 16.5L6 16.5L6 8.5Z", fill: "currentColor" }));
export default SvgArrowUp;
